// extracted by mini-css-extract-plugin
export default {"file-button__icon":"file-button_file-button__icon__yRjwC","file-button__button":"file-button_file-button__button__2S3d5"};